"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HealthOutcomesExportButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _components = require("../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var HealthOutcomesExportButton = function HealthOutcomesExportButton(_ref) {
  var patientId = _ref.patientId;
  var onExport = function onExport(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open((0, _utils.getHealthOutcomesPatientExportUrl)(patientId), '_blank');
  };
  return /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    onClick: onExport
  }, "Export log");
};
exports.HealthOutcomesExportButton = HealthOutcomesExportButton;